module.exports = __webpack_public_path__ + "assets/images_base/st-logo.svg?v=8d736e9e";